import React from "react";

const SceneGraphContextMenuContext = React.createContext(null);

export function SceneGraphContextMenuProvider({ value, children }) {
  return (
    <SceneGraphContextMenuContext.Provider value={value}>
      {children}
    </SceneGraphContextMenuContext.Provider>
  );
}

export function useSceneGraphContextMenuModel() {
  const value = React.useContext(SceneGraphContextMenuContext);
  if (!value) {
    throw new Error("SceneGraphContextMenu must be rendered inside SceneGraphContextMenuProvider");
  }
  return value;
}
